import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'app/auth/auth.service';
import { ComplaintDialogService } from 'app/services/complaints/complaint-dialog.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-complaints',
  templateUrl: './complaints.component.html',
  styleUrls: ['./complaints.component.scss'],
})
export class ComplaintsComponent implements OnInit {
  constructor(
    private readonly complaintDialogService: ComplaintDialogService,
    private readonly authService: AuthService,
    private readonly router: Router,
  ) {}

  ngOnInit(): void {
    this.complaintDialogService.open().afterClosed().pipe(take(1)).subscribe(() => {
      this.router.navigateByUrl(this.authService.isAuthorized() ? '/dashboard' : '/home', { replaceUrl: true });
    });
  }
}
